module.exports = __webpack_public_path__ + "html/press-swipable_822a28fed7f1de684ff5dbb1dcc77b38.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/press-swipable.html
// module id = l0GU
// module chunks = 55